import { capitalise } from '@agria/utils';
import { useStaticQuery, graphql } from 'gatsby';

export const useIsPetOrAnimal = (): {
  petOrAnimal: 'pet' | 'animal';
  yourThe: 'your' | 'the';
  yourTheCaps: 'Your' | 'The';
  yourTheir: 'your' | 'their';
  yourTheirCaps: 'Your' | 'Their';
} => {
  const data = useStaticQuery(graphql`
    query IsPetOrAnimalQuery {
      site {
        siteMetadata {
          petOrAnimal
        }
      }
    }
  `);

  const yourThe = data.site.siteMetadata.petOrAnimal === 'pet' ? 'your' : 'the';
  const yourTheCaps = capitalise(yourThe);

  const yourTheir =
    data.site.siteMetadata.petOrAnimal === 'pet' ? 'your' : 'their';
  const yourTheirCaps = capitalise(yourTheir);

  return {
    ...data.site.siteMetadata,
    yourThe,
    yourTheCaps,
    yourTheir,
    yourTheirCaps,
  };
};
